/* eslint-disable spaced-comment */
/* eslint-disable no-unused-vars */
import Api from '@/api/index'

const service = {
  actions: {
  // 获取在线看房列表
    postVisitHouse ({commit}, object) {
      return new Promise((resolve, reject) => {
        Api.postVisitHouse(object).then(response => {
          //请求成功回调
          resolve(response)
        }).catch(error => {
          //请求失败回调
          reject(error)
        })
      })
    },
    // 在线看房详情
    postVisitHouseDetail ({commit}, object) {
      return new Promise((resolve, reject) => {
        Api.postVisitHouseDetail(object).then(response => {
          //请求成功回调
          resolve(response)
        }).catch(error => {
          //请求失败回调
          reject(error)
        })
      })
    },
    // 标签列表
    postVisitHouseLabel ({commit}, object) {
      return new Promise((resolve, reject) => {
        Api.postVisitHouseLabel(object).then(response => {
          //请求成功回调
          resolve(response)
        }).catch(error => {
          //请求失败回调
          reject(error)
        })
      })
    }
  }
}

export default service



// WEBPACK FOOTER //
// ./src/service/service.js